// import "babel-polyfill";
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import createHistory from 'history/createBrowserHistory';
import { composeWithDevTools } from 'redux-devtools-extension';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import ApplicationReducer from './reducers/';
import ApiMiddleware from './middlewares/api';
import App from './App';
import './../node_modules/swiper/dist/css/swiper.css';
import './sass/index.scss';


const history = createHistory();
const routersMiddleware = routerMiddleware(history);
const store = createStore(ApplicationReducer,
    composeWithDevTools(applyMiddleware(thunk, routersMiddleware, ApiMiddleware)));

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <App />
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
);




// WEBPACK FOOTER //
// ./src/index.jsx